import { useQuery } from '@apollo/client/react'
import {
  OrgTicketDocument,
  type OrgTicketQuery,
} from '@/graphql/generated/graphql'

export type OrgTicketDetail = OrgTicketQuery['orgTicket']
export type OrgTicketComment = OrgTicketDetail['comments'][number]
export type OrgTicketAttachment = OrgTicketDetail['attachments'][number]

/** Detalle de un ticket (hilo PÚBLICO + adjuntos visibles + confirmación). */
export function useOrgTicket(code: string) {
  const { data, loading, error, refetch } = useQuery(OrgTicketDocument, {
    variables: { code },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  return {
    detail: data?.orgTicket ?? null,
    loading,
    error,
    refetch,
  }
}
